import React, { FC } from 'react';
import { Theme, Typography, styled } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';

const StyledParagraph = styled(Typography)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const Paragraph: FC<TypographyProps> = (props) => (
  <StyledParagraph data-testid="dm-paragraph" variant="body2" {...props} />
);

export default Paragraph;
